import React from "react";
import {
  Row,
  Col
} from "reactstrap";
import ReactSelect from "react-select";
import Select from "components/forms/Select";
import {
  LISTA_TEMATICAS,
  getObjectTematica
} from "../../data/marco-ordenador.data";
class BarraSelecionarTematica extends React.Component {
  constructor(props) {
    super(props);
    this._onTematicaChange = this._onTematicaChange.bind(this);
  }
  render() {
    let tematicaSelecionada = getObjectTematica(this.props.tematica);
    return (
      <Row>
        <Col xs={12} sm={12} md={4} xl={4}>
        <Select
            store={LISTA_TEMATICAS}
            item_default={tematicaSelecionada}
            onChange={this._onTematicaChange}
            scope={this}
            placeholder="Seleccione temática"
        />
        </Col>
      </Row>
    );
  }
  _onTematicaChange1(objTematica) {
    if (this.props.onTematicaChange) {
      let scope = this.props.scope || this;
      this.props.onTematicaChange.call(scope, objTematica.value);
    }
  }
  _onTematicaChange(itemsSeleccionados) {
    let props = this.props;
    let scope = this.props.scope || this;
    if (props.onTematicaChange) {
      props.onTematicaChange.call(scope, itemsSeleccionados[0].value);
    }
  }
}
export default BarraSelecionarTematica;
